@ -1,47 +1,60 @@
<template>
  <div>
    <CardWithImageAndButton 
    title="Генератор синтетических данных «Спутник»"
    text="
    Система предназначена для автоматизированной генерации синтетических данных, соответствующих заданными пользователем критериям и требованиям. 
    <br /><br />
    Основное назначение Системы – обеспечение разработчиков, тестировщиков, аналитиков и специалистов по машинному обучению валидными, безопасными и реалистичными данными для использования в различных сценариях, включая разработку приложений, тестирование программного обеспечения, аналитические исследования и обучение моделей искусственного интеллекта.
    <br /><br />
    Используемые технологии: Go, JavaScript.
    "
    :imagePath="require('../../assets/imgs/data-generator.png')"
    imagePosition="left"
    :buttonIsVisible="false"
    />

    <NumberedList :items="listItems" text="" title="Уникальные свойства" theme="dark" />

    <List
    :items="documentItems"
    title="Документы"
    />
  </div>
</template>

<script>
import { CardWithImageAndButton, NumberedList, List } from 'sputnik-ui/src/index';
export default {
  name: 'DataGeneratorPage',
  components: {
    CardWithImageAndButton,
    NumberedList,
    List
  },
  data() {
    return {
      listItems: [
        {title: "Безопасность данных", text: "Генерация полностью синтетических данных исключает риск утечки или использования реальных персональных данных."},
        {title: "Гибкость", text: "Система позволяет пользователю самостоятельно настраивать количество и тип генерируемых полей, а также добавлять пользовательские поля в соответствии с конкретными требованиями."},
        {title: "Масштабируемость", text: "Возможность генерации любого объема данных с сохранением высокой производительности."},
        {title: "Валидация и качество", text: "Автоматическая проверка данных на соответствие заданным правилам и стандартам, включая корректность форматов, уникальность значений и соблюдение бизнес-логики."},
      ],
      documentItems: [
        { text: 'Описание функциональных характеристик', onClick: () => window.open('/docs/Описание_функциональных_характеристик_Синтезатора.pdf', '_blank') },
        { text: 'Руководство оператора', onClick: () => window.open('/docs/Руководство_оператора_Синтезатор.pdf', '_blank') },
        { text: 'Описание процессов жизненного цикла', onClick: () => window.open('/docs/Описание_процессов_жизненного_цикла_Синтезатор.pdf', '_blank') },
        { text: 'Описание технической архитектуры', onClick: () => window.open('/docs/Описание_технической_архитектуры_Синтезатора.pdf', '_blank') },
        { text: 'Описание технических средств хранения и компиляции', onClick: () => window.open('/docs/Описание_технических_средств_хранения_и_компиляции.pdf', '_blank') },
      ]
    };
  },
};
</script>


<style lang="scss" scoped>
  .wrapper {
    padding-top: 50px;
    padding-bottom: 50px;
  }
</style>